'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

let check = false; // eslint-disable-line import/no-mutable-exports

const regex = /(android|iphone|ipad|mobile|phone|mobi|blackberry)/i;

(function (str) {
  const testString = str.toLowerCase();

  if (regex.test(testString)) {
    check = true;
  }
})(navigator.userAgent || navigator.vendor || window.opera);

var check$1 = check;

exports.default = check$1;
